module.exports = __webpack_public_path__ + "img/verify-success.ff622ad0.png";